import { BrowserRouter as Router, Routes, Route, Outlet, RouterProvider, ScrollRestoration } from "react-router-dom";
import router from "./router/Index";
import { useProfileStore } from "./store/useUserStore";
import { useEffect } from "react";

function App() {
  
    return (
        <>
        <RouterProvider router={router} />
        </>
    )
}

export default App;
// <Router>
//       <Routes>
//             <Route path={process.env.PUBLIC_URL + "/"} element={<Welcome/>} />
//             <Route element={<DefaultLayout> <Outlet /> </DefaultLayout>}>
//                 <Route path={process.env.PUBLIC_URL + "/profile"} element={<Profile/>} />
//                 <Route path="*" element={<NotFound/>} />
//             </Route>
//       </Routes>
// </Router>